
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|1722|3382|5464)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
